const roundDown = (unformattedValue, roundFactor) => {
  return Math.floor(unformattedValue * roundFactor) / roundFactor
}
const roundUp = (unformattedValue, roundFactor) => {
  return Math.ceil(unformattedValue * roundFactor) / roundFactor
}
const roundCloser = (unformattedValue, roundFactor, decimalScale = 0) => {
  const sign = unformattedValue >= 0 ? 1 : -1
  return (Math.round(unformattedValue * roundFactor + sign * 0.001) / roundFactor).toFixed(
    decimalScale
  )
}

export { roundDown, roundUp, roundCloser }
